import { useDeleteCartRowMutation, useEditCartRowMutation, useEditCartRowOptionMutation } from "@/api/cart"
import WheelSearchQueryParams from "@/types/WheelSearchQueryParams"
import { CartRowModel, ProductType } from "@/types/api"
import { buildQueryString } from "../helpers"

const useCartRow = (row: CartRowModel) => {
  const [removeRow] = useDeleteCartRowMutation()
  const [updateRow] = useEditCartRowMutation()
  const [updateRowOption] = useEditCartRowOptionMutation()

  const getUpdateObject = () => {
    return {
      id: row.id,
      quantity: row.quantity,
      articleId: row.articleId,
      reference: row.reference,
      licensePlate: row.licensePlate,
    }
  }

  const updateQuantity = (quantity: number) => {
    if (quantity < 1) {
      remove()
      return
    }

    const updateObject = getUpdateObject()
    updateObject.quantity = quantity
    updateRow(updateObject)
  }

  const updateReference = (reference: string) => {
    const updateObject = getUpdateObject()
    updateObject.reference = reference
    updateRow(updateObject)
  }

  const updateOption = (optionId: number, valueId: number) => {
    updateRowOption({ id: row.id, optionId, valueId })
  }

  const remove = () => {
    removeRow(row.id)
  }

  return {
    remove,
    updateQuantity,
    updateReference,
    updateOption
  }
}

export default useCartRow